// extracted by mini-css-extract-plugin
module.exports = {"minPriceContainer":"min_price_panel_minPriceContainer__3flhX","minPriceContent":"min_price_panel_minPriceContent__3yWAU","minPrice":"min_price_panel_minPrice__17_Kh"};